import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { DocumentsActions } from './documents.actions';
import { DocumentsSelectors } from './documents.selectors';

@Injectable({ providedIn: 'root' })
export class DocumentsStore {
  state$ = this.store.select(DocumentsSelectors.selectState());
  documents$ = this.store.select(DocumentsSelectors.selectDocuments());
  updatedDocuments$ = this.store.select(DocumentsSelectors.selectUpdatedDocuments());
  termsOfUseDocument$ = this.store.select(DocumentsSelectors.selectTermsOfUseDocument());
  dataUsageAgreementDocument$ = this.store.select(
    DocumentsSelectors.selectDataUsageAgreementDocument()
  );

  constructor(private store: Store) {}

  getDocuments(): void {
    this.store.dispatch(DocumentsActions.getDocuments());
  }

  getDataUsageAgreementDocument(): void {
    this.store.dispatch(DocumentsActions.dataUsageAgreementDocument.attempt());
  }

  getDocumentsUpdated(userCountryCode: string): void {
    this.store.dispatch(DocumentsActions.getUpdatedDocuments({ userCountryCode }));
  }

  agreeOnDocuments(): void {
    this.store.dispatch(DocumentsActions.agreeOnDocuments());
  }
}
